/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  Expression,
  Icon,
  List,
  LocalizedString128,
  SiteSectionGroup,
  SiteSectionGroupMovePosition,
  SiteSectionGroupTitle,
  SubscriptionNotice,
} from "./data-contracts";

/**
 * @description Returns a paginated list of section groups for the site. Section groups are containers that organize multiple sections into a hierarchical navigation structure. Use this to inspect the current grouping before adding, updating, or reordering items in the site structure.
 * @tags site-section-groups
 * @name ListSiteSectionGroups
 * @summary List all section groups in a site's navigation structure
 * @request GET:/orgs/{organizationId}/sites/{siteId}/section-groups
 * @secure
 */

// @ts-ignore
export const listSiteSectionGroups: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteSectionGroup[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/section-groups",
  method: "get",
  streaming: false,
  tags: ["site-section-groups"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Creates a new section group to organize multiple sections under a shared navigation label. Section groups can be nested by providing a parent group ID. Existing sections can be assigned to the group at creation time via their IDs. Create the group in draft mode to stage it before publishing.
 * @tags site-section-groups
 * @name AddSectionGroupToSite
 * @summary Add a section group to a site's navigation structure
 * @request POST:/orgs/{organizationId}/sites/{siteId}/section-groups
 * @secure
 */

// @ts-ignore
export const addSectionGroupToSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the site section group */
    title: SiteSectionGroupTitle;
    /** Conditional expression used to evaluate whether the site section group should be shown to the site's visitor (should evaluate to a boolean). */
    condition?: Expression;
    icon?: Icon | null;
    /** IDs of the sections to be added to the section group */
    sections?: string[];
    /** ID of the parent section group to nest this group under. If not provided, the section group will be added at the root of the site. */
    parent?: string;
    /** Whether the section group should be created in draft mode. */
    draft?: boolean;
  };
  RequestHeaders: {};
  ResponseBody: SiteSectionGroup & {
    /** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
    subscriptionNotice?: SubscriptionNotice;
  };
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/section-groups",
  method: "post",
  streaming: false,
  tags: ["site-section-groups"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates a section group's properties in the site's navigation structure.
 * @tags site-section-groups
 * @name UpdateSiteSectionGroupById
 * @summary Update a section group in a site's navigation structure
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}
 * @secure
 */

// @ts-ignore
export const updateSiteSectionGroupById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site group */
    siteSectionGroupId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the site section group */
    title?: SiteSectionGroupTitle;
    /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
    localizedTitle?: LocalizedString128;
    /** Conditional expression used to evaluate whether the site section group should be shown to the site's visitor (should evaluate to a boolean). If not set, the condition will remain unchanged. If set to null, the condition will be removed. */
    condition?: Expression | null;
    icon?: Icon | null;
    /** Whether the site section group should be kept in draft mode. Setting it to true makes the site section group draft. Setting it to false makes the site section group live. */
    draft?: boolean;
    /** ID of the parent section group to move this section group into. Set to null to move the section group to the root of the site. */
    parentSectionGroupId?: string | null;
  };
  RequestHeaders: {
    /** Control whether a successful response includes the updated resource representation. */
    prefer?: "return=minimal" | "return=representation";
  };
  ResponseBody: SiteSectionGroup | undefined;
  ResponseStatusCode: 200 | 204;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}",
  method: "patch",
  streaming: false,
  tags: ["site-section-groups"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-section-groups
 * @name DeleteSiteSectionGroupById
 * @summary Delete a site section group
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}
 * @secure
 */

// @ts-ignore
export const deleteSiteSectionGroupById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site group */
    siteSectionGroupId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}",
  method: "delete",
  streaming: false,
  tags: ["site-section-groups"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-section-groups
 * @name MoveSiteSectionGroup
 * @summary Move a site section group to a new position. (Deprecated) use sortSiteStructure instead.
 * @request POST:/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}/move
 * @deprecated
 * @secure
 */

// @ts-ignore
export const moveSiteSectionGroup: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site group */
    siteSectionGroupId: string;
  };
  RequestQuery: {};
  RequestBody:
    | {
        /** The position where to move the site section group. When not provided the site section group is moved at the end of the site. */
        position?: SiteSectionGroupMovePosition;
      }
    | undefined;
  RequestHeaders: {};
  ResponseBody: SiteSectionGroup;
  ResponseStatusCode: 200 | 400 | 404;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/section-groups/{siteSectionGroupId}/move",
  method: "post",
  streaming: false,
  tags: ["site-section-groups"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: { errorRate: 0 },
};
